import { useEffect } from 'react';
import { useHistory } from 'react-router';

const PostLoginRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    const savedPath = sessionStorage.getItem('redirectAfterLogin');
    if (savedPath) {
      sessionStorage.removeItem('redirectAfterLogin');
      if (savedPath !== history.location.pathname) {
        history.replace(savedPath);
      }
    }
  }, []);

  return null;
};

export default PostLoginRedirect;
